module.exports = __webpack_public_path__ + "img/xylophone.906df66b.jpeg";